import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var CompareSVG = function CompareSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M20.649,17.89a2.573,2.573,0,0,0-3.525.007L8.805,25.76A2.568,2.568,0,0,0,8,27.628v11.75a2.571,2.571,0,0,0,2.571,2.571H27.286a2.571,2.571,0,0,0,2.571-2.571V27.635a2.569,2.569,0,0,0-.813-1.876Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M15.649,14.89a2.573,2.573,0,0,0-3.525.007L3.805,22.76A2.568,2.568,0,0,0,3,24.628v11.75a2.571,2.571,0,0,0,2.571,2.571H22.286a2.571,2.571,0,0,0,2.571-2.571V24.635a2.569,2.569,0,0,0-.813-1.876Zm6.637,21.488H5.571V24.629l8.317-7.863h0l8.4,7.869Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M10.341,27.751a1.29,1.29,0,1,0-1.825,1.825l2.571,2.572a1.319,1.319,0,0,0,.913.373,1.234,1.234,0,0,0,.8-.283L19.226,27.1a1.281,1.281,0,0,0-1.595-2.006L12.09,29.512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M33.7,10.946,31.376,12.8l-.463-.476a1.291,1.291,0,0,0-1.826,1.826l1.286,1.285a1.313,1.313,0,0,0,.913.373,1.236,1.236,0,0,0,.8-.283L35.3,12.952A1.281,1.281,0,1,0,33.7,10.946Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M38.158,8.306,32.793,3.293a1.258,1.258,0,0,0-1.729,0L25.7,8.306a2.674,2.674,0,0,0-.842,1.955v8.081a1.3,1.3,0,0,0,1.286,1.321H37.714A1.3,1.3,0,0,0,39,18.342V10.261A2.674,2.674,0,0,0,38.158,8.306Zm-1.729,8.786h-9V10.261a.118.118,0,0,1,.025-.077L31.929,6l4.474,4.18a.117.117,0,0,1,.026.077Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M23,6.949a.993.993,0,0,1-.707-.293l-2-2a1,1,0,0,1,1.414-1.414l2,2A1,1,0,0,1,23,6.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M22,10.949H19a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M34,26.949a1,1,0,0,1-1-1v-3a1,1,0,1,1,2,0v3A1,1,0,0,1,34,26.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M40,25.949a.993.993,0,0,1-.707-.293l-2-2a1,1,0,1,1,1.414-1.414l2,2A1,1,0,0,1,40,25.949Z"
  }));
};
CompareSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
CompareSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Compare")
};
export default withDetailedIcon(CompareSVG);